import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})

export class ForgotPasswordComponent {
  public env = environment;
  public forgotPasswordForm: UntypedFormGroup;
  hidePwd: boolean = false;
  errorMsg: string = '';

  constructor(private fb: UntypedFormBuilder, private apiSer: ApiService, private _router: Router, public _shared: SharedService) {
    this.forgotPasswordForm = this.fb.group({
email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]]
    })
  }

  public submit() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAsDirty();
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }
    const data = {
      doctor_email: this.forgotPasswordForm.controls['email'].value
    };
    this.apiSer.api(data, 'auth/forgot_password').subscribe((response) => {
      if (response.is_error == 0) {
        this._router.navigate(['login']);
        this._shared.customPopups('Password sent to your mail successfully', 3);
        return;
      } else {
        this.forgotPasswordForm.markAllAsTouched();
        this.forgotPasswordForm.markAsDirty();
        this.errorMsg = response.original_text;
        console.log(this.forgotPasswordForm);
        // this._shared.customPopups(response.original_text, 1);

        window.scroll(0, 0);
      }
    });
  }
  onEmailInput(event: any) {
    let value = event.target.value;
    value = value.replace(/\s/g, '');
    value = value.trim();
    event.target.value = value;
    this.forgotPasswordForm.get('email')?.setValue(value, { emitEvent: false });
  }
}
